import { NgModule } from '@angular/core';

import { StringToIdPipe } from './string-to-id.pipe';

@NgModule({
  declarations: [StringToIdPipe],
  exports: [StringToIdPipe],
})
export class StringToIdPipeModule {}
